import { render, staticRenderFns } from "./BannerPrincipalCampanha.vue?vue&type=template&id=57ab694c&scoped=true"
import script from "./BannerPrincipalCampanha.vue?vue&type=script&lang=js"
export * from "./BannerPrincipalCampanha.vue?vue&type=script&lang=js"
import style0 from "./BannerPrincipalCampanha.vue?vue&type=style&index=0&id=57ab694c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ab694c",
  null
  
)

export default component.exports